import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';
import { AppRole, useAuth } from '@/contexts/AuthContext';

interface CreateUserParams {
  email: string;
  password: string;
  name: string;
  role: AppRole;
  professional_id?: string | null;
  cluster_id?: string | null;
}

export function useCreateUser() {
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();
  const { isDemo } = useAuth();

  const createUser = async (params: CreateUserParams): Promise<boolean> => {
    if (isDemo) {
      toast({
        variant: 'destructive',
        title: 'Ação indisponível em modo demo',
        description: 'Criação de usuários desabilitada para ambiente demo.',
      });
      return false;
    }
    setLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke('create-user', {
        body: params,
      });

      if (error) {
        toast({
          variant: 'destructive',
          title: 'Erro ao criar usuário',
          description: error.message,
        });
        return false;
      }

      if (data?.error) {
        toast({
          variant: 'destructive',
          title: 'Erro ao criar usuário',
          description: data.error,
        });
        return false;
      }

      toast({
        title: 'Usuário criado',
        description: 'O usuário foi criado com sucesso.',
      });
      return true;
    } catch (error: any) {
      toast({
        variant: 'destructive',
        title: 'Erro ao criar usuário',
        description: error.message || 'Erro desconhecido',
      });
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { createUser, loading };
}
